var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.656,
    height: 35.222,
    viewBox: "0 0 24.656 35.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contrase\\xF1a",
    transform: "translate(-1107.229 -682.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19207",
    "data-name": "Trazado 19207",
    d: "M1110.076,695.841h18.962a1.862,1.862,0,0,1,1.847,1.848V710.3c0,3.374-2.217,6.158-5.592,6.158H1113.82c-3.374,0-5.591-2.771-5.591-6.158v-12.61a1.852,1.852,0,0,1,1.847-1.848Z",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 22.926,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19208",
    "data-name": "Trazado 19208",
    d: "M1112.209,695.536v-6.22a5.737,5.737,0,0,1,6.081-6.081h2.533a5.739,5.739,0,0,1,6.08,6.081v6.22m-6.2,11.383,1.429,4.316h-5.159l1.471-4.3a2.834,2.834,0,1,1,2.259-.018Z",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.336a2a5826061ea4a146899d2d668044.svg";
export { ForwardRef as ReactComponent };